import { createTheme } from '@mui/material/styles';
import '@fontsource/kanit'; // ฟอนต์ภาษาไทย

const theme = createTheme({
  typography: {
    fontFamily: 'Kanit, sans-serif',
  },

});

export default theme;
